import React, { useState, useRef } from "react";
import { Box, Button, Dialog, DialogContent, IconButton, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EditNoteIcon from '@mui/icons-material/EditNote';
import LoarAgreementForm from "../LoanAgreement_Components/Forms/LoanAgreement";
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';
import RepaymentStatus from "../LoanAgreement_Components/Forms/ManageRepayment_Status";
import App from "../LoanAgreement_Components/LoanApplicationDocuments_Upload";

const LoanApplicationAgreement: React.FC = () => {
  const [open, setOpen] = useState(false);
  const contentRef = useRef<HTMLDivElement>(null);

  const handleClose = () => {
    setOpen(false);
  };

  const handleExportToPDF = async () => {
    const contentElement = contentRef.current;
    if (contentElement) {
      const pdf = new jsPDF('p', 'mm', 'a4');
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const totalScrollHeight = contentElement.scrollHeight;

      // Temporarily disable scrolling to ensure consistent capturing
      contentElement.style.overflowY = 'hidden';

      // Create a canvas for the entire content
      const canvas = await html2canvas(contentElement, {
        scale: 2,
        useCORS: true,
        windowWidth: contentElement.scrollWidth,
        windowHeight: totalScrollHeight, // Capture the full height
      });

      const imgData = canvas.toDataURL('image/png');
      const imgHeight = (canvas.height * pdfWidth) / canvas.width;

      // Calculate number of pages needed if the content height exceeds page height
      const pageHeight = pdf.internal.pageSize.getHeight();
      let heightLeft = imgHeight;
      let position = 0;

      // Add images to PDF with pagination if necessary
      while (heightLeft >= 0) {
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, imgHeight);
        heightLeft -= pageHeight;
        position -= pageHeight;

        if (heightLeft >= 0) {
          pdf.addPage();
        }
      }

      // Restore original scroll behavior
      contentElement.style.overflowY = 'scroll';

      // Save the final PDF
      pdf.save('loan_agreement_complete.pdf');
    }
  };

  const iconStyle = {
    fontSize: '5rem',
    transition: 'transform 0.3s ease-in-out',
    '&:hover': {
      transform: 'scale(1.2)',
    },
  };

  return (
    <div>
      <Button
        sx={{
          bgcolor: 'var(--color-ocean-default)',
          color: 'var(--color-offwhite)',
          py: '20px',
          ':hover': {
            bgcolor: 'var(--color-ocean-highlight)',
            color: 'var(--color-dark-gray)',
          },
          height: '130px',
          maxWidth: '358px',
          mr: 2,
          flexDirection: 'column',
          gap: 1,
        }}
        fullWidth
        size="large"
        variant="contained"
        startIcon={<EditNoteIcon sx={{ mr: '10px' }} style={iconStyle} />}
        onClick={() => setOpen(true)}
      >
        Loan Application
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth="md"
        fullScreen
        PaperProps={{
          style: {
            backgroundColor: 'rgba(140, 170, 100, 0.95)',
            boxShadow: 'none',
            marginTop: '180px',
            marginRight: '140px',
            marginLeft: '130px',
            height: '750px',
            marginBottom: '100px',
          },
        }}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '16px' }}>
          <Typography
            className="bold-text"
            sx={{
              color: 'var(--color-ocean-highlight)',
              fontSize: '24px',
              height: '56px',
              maxWidth: '100%',
              ml: '20px',
            }}
            align="left"
            variant="h4"
            gutterBottom
          >
            PERSONAL LOAN AGREEMENT
          </Typography>

          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <Button
              onClick={handleExportToPDF}
              variant="contained"
              color="primary"
              sx={{ mr: 1 }} // margin right to separate from icon button
            >
              Export to PDF
            </Button>

            <IconButton
              onClick={handleClose}
              aria-label="close"
              sx={{
                color: "grey.600",
                borderRadius: "50%",
                width: "40px",
                height: "40px",
                "&:hover": {
                  backgroundColor: "rgba(0, 0, 0, 0.1)",
                },
              }}
            >
              <CloseIcon
                sx={{
                  border: "2px solid #ff7f7f",
                  borderRadius: "4px",
                  padding: "4px",
                }}
              />
            </IconButton>
          </Box>
        </Box>

        <DialogContent sx={{ marginTop: '10px', maxHeight: '500px', overflowY: 'scroll' }}>
          {/* Reference for the content */}
          <div ref={contentRef}>
            <LoarAgreementForm />
            {/* <App/> */}
            
          </div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default LoanApplicationAgreement;
